import store from "../store";

export default function authHeader() {
  const user = JSON.parse(localStorage.getItem('user'));
  if (user && user.access_token) {
    return { 'Authorization': "Bearer " + user.access_token };
  } else if(store.state.user !== '') {
    return { 'Authorization': "Bearer " + store.state.user.access_token };
  } else {
    return {};
  }
}
